export default {
  compact: true,
  href: '/my-health/',
  hrefInjectedHeader: 'https://va.gov/my-health/',
  title: 'My HealtheVet',
};
